export default {
  primary: "#009688",
  primaryOverlay: "ccf2e2",
  buttonColor: "#009688",
  buttonColorSecondary: "#009688"
};
